import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { AirdiskEmailComponent } from '../airdisk-email/airdisk-email.component';
import { ViewportScroller } from '@angular/common';
import { Subscription, take } from 'rxjs';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';

@Component({
  selector: 'app-airdisk-drum-summary',
  templateUrl: './airdisk-drum-summary.component.html',
  styleUrls: ['./airdisk-drum-summary.component.scss'],
  standalone: false
})
export class AirdiskDrumSummaryComponent {
  tableData: any[];
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef,
    private readonly matdialog: MatDialog, private readonly viewPortScroller: ViewportScroller,
    private globalmsgService: GlobalMessageService,
  ) {
    this.airdiskService.TableCalculation();
  }
  endurasureSummaryForm = new FormGroup({});
  get form() {
    return this.endurasureSummaryForm.controls;
  }
  endaSureBack() {
    this.airdiskService.currentComponent$.next('costSummary');
    this.cdr.detectChanges();
  }
  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe(option => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    });

    this.airdiskService.summaryData$.subscribe(x => {
      this.tableData = x;
      this.cdr.detectChanges();
    })
  }

  emailPopup() {
    this.viewPortScroller.scrollToPosition([0, 0]);
    this.matdialog.open(AirdiskEmailComponent).afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result?.status === 'Success') {
          this.globalmsgService.add(
            { key: result.message },
            GlobalMessageType.MSG_TYPE_INFO
          );
        }
      });
  }
  resetForms() {
    this.airdiskService.triggerReset();
    this.airdiskService.currentComponent$.next('visitorInfo');
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.subscription.unsubscribe();
  }
}
